import { useState } from "react";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import { FaEye, FaPlus } from "react-icons/fa";
import { PropagateLoader } from "react-spinners";
import DataTable from "react-data-table-component"
import IconButton from "../../atoms/IconButton";
import NoData from "../../molecules/NoData"
import ModalConfirm from "../../molecules/ModalConfirm";
import useModal from "../../../hooks/useModal";
import { DELETE_GASTO } from "../../../api/apiGastos";
import { formatDate } from "../../../utils/formatDate";
import { formatCurrency } from "../../../utils/formatCurrency";
import ExpandedCell from "../../atoms/ExpandedCell";
import { VIEW_FILE } from "../../../api/apiFiles";
import Modal from "../../molecules/Modal";
import GastosUpdateFile from "./GastosUpdateFile";

const GastosTable = ({ data, refetch, loading, inmuebles }) => {
    const [selected, setSelected] = useState(null);
    const [loadingActions, setLoadingActions] = useState();
    const { open, isOpen, close } = useModal();
    const [loadingView, setLoadingView] = useState();
    const [fileUrl, setFileUrl] = useState(null);
    const { open: openView, isOpen: isOpenView, close: closeView } = useModal();
    const { open: openUpload, isOpen: isOpenUpload, close: closeUpload } = useModal();

    const handleOpenView = async (s3Key) => {
        openView();
        setSelected(s3Key);
        setLoadingView(true);
        try {
            const response = await VIEW_FILE({ s3Key });
            if (response) {
                setFileUrl(response);
            } else {
                console.error("No se pudo obtener la URL del archivo");
            }
        } catch (error) {
            console.error("Error al cargar el archivo:", error);
            toast.error("Error al cargar el archivo");
        } finally {
            setLoadingView(false);
        }
    };

    const handleOpenDelete = (gasto) => {
        open();
        setSelected(gasto);
    };

    const handleOpenUpload = (gasto) => {
        openUpload();
        setSelected(gasto);
    };

    const handleClose = () => {
        close();
        closeView();
        closeUpload();
        setSelected(null);
    };

    const getInmuebleName = (propertieId) => {
        const inmueble = inmuebles?.find((item) => item.id === propertieId);
        return inmueble ? inmueble.name : "Inmueble desconocido";
    };

    const columns = [
        {
            name: "Inmueble",
            selector: (row) => getInmuebleName(row.propertieId),
        },
        { name:"Gasto", selector: row =>(
            <div className="grid grid-cols-1">
                <strong> {row.name} </strong>
                <ExpandedCell text={row.comments} />
            </div>
        )},
        { name:"Costo", cell: row =>
            <div className="flex flex-col gap-1">
                <p>Total: {formatCurrency(row.amount)} </p>
                <p>IVA: {formatCurrency(row.iva)} </p>
                <p>Subtotal: {formatCurrency(row.subtotal)} </p>
            </div>
        },
        { name:"Fecha", cell: row =>
            <div className="flex flex-col gap-1">
                <p> {formatDate(row.createdAt)} </p>
                <p> pago con: {row.forma_pago} </p>
                <p> {row.titular} </p>
            </div>
        },
        { name:"Acciones", cell: row => (
            <div className="grid grid-cols-2 gap-2">
                <IconButton
                    icon={row.file ? FaEye : FaPlus}
                    bgColor="bg-rs-azul"
                    size="min-w-8 max-w-8" iconSize="text-2xl"
                    onClick={row.file ? ()=> handleOpenView(row.file.s3Key) : ()=> handleOpenUpload(row) }
                />
                <IconButton
                    icon={MdDelete}
                    bgColor="bg-rs-rojo"
                    onClick={()=> handleOpenDelete(row)}
                    size="min-w-8 max-w-8" iconSize="text-2xl"
                />
            </div>
        )},
    ];

    const handleDelete = () => {
        setLoadingActions(true);
        toast.promise(
            DELETE_GASTO(selected.id),
            {
                pending: 'Eliminando gasto...',
                success: 'Gasto eliminado correctamente.',
                error: 'No se pudo eliminar el gasto.'
            }
        ).then(() => {
            refetch();
            handleClose();
        }).catch((error) => {
            console.error(error);
        }).finally(()=> {
            setLoadingActions(false);
        });
    };

    return(
        <>
            <DataTable
                data={data}
                progressPending={loading}
                columns={columns}
                progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                noDataComponent={<NoData />}
                pagination
            />
            {isOpen && <ModalConfirm loading={loadingActions} onClose={handleClose} onConfirm={handleDelete} eliminacion /> }
            {isOpenView && selected &&
                <Modal title="Factura" onClose={handleClose}>
                    {loadingView ?
                            <PropagateLoader color="red" />
                        :
                            <iframe src={fileUrl} title="Factura" className="w-full h-[85vh]" />
                    }
                </Modal>
            }
            {isOpenUpload && selected &&
                <Modal title="Subir factura o recibo" onClose={handleClose} >
                    <GastosUpdateFile gasto={selected} refetch={refetch} onClose={handleClose} />
                </Modal>
            }
        </>
    );
};

export default GastosTable;